import { cn } from '@/lib/utils';
import { STATUS_INDICATOR_CLASSES } from '@/components/ui/field-trigger';
import { PRODUCT_STATUS_CONFIG } from '../product-status-config';
import type { ProductStatus } from '../types';

interface ProductStatusBadgeProps {
  status: ProductStatus;
}

export function ProductStatusBadge({ status }: ProductStatusBadgeProps) {
  const statusConfig = PRODUCT_STATUS_CONFIG[status];

  return (
    <div
      className={cn(STATUS_INDICATOR_CLASSES, statusConfig.textClassName)}
    >
      <span className="flex items-center gap-2">
        {statusConfig.icon}
        {statusConfig.label}
      </span>
    </div>
  );
}
